// Top banner word switcher
const words = ['brand', 'communication', 'direction', 'design'];
let wordIndex = 0;

function cycleWords() {
  const sentenceElement = document.getElementById('sentence');
  if (sentenceElement) {
    sentenceElement.textContent = `${words[wordIndex]} is ${words[(wordIndex + 1) % words.length]} is ${words[(wordIndex + 2) % words.length]} is ${words[(wordIndex + 3) % words.length]}`;
  }
  wordIndex = (wordIndex + 1) % words.length;
  setTimeout(cycleWords, 2000);
}

// Random fig. numbers
function updateFigureNumbers() {
  const numberSpans = document.querySelectorAll('.r');
  numberSpans.forEach(span => {
    span.textContent = `${Math.floor(Math.random() * 100) + 2}`;
  });
}

// Lock words on scroll
function initHighlightForLockScrollSection(lockScrollSection) {
  const sentences = lockScrollSection.querySelectorAll('.sentence');
  let currentSentenceIndex = -1;
  
  window.addEventListener('scroll', () => {
    let mostVisibleSentenceIndex = -1;
    let closestDistance = Infinity;

    sentences.forEach((sentence, index) => {
      const rect = sentence.getBoundingClientRect();
      const distanceToCenter = Math.abs(rect.top + rect.bottom - window.innerHeight);
      
      if (distanceToCenter < closestDistance) {
        closestDistance = distanceToCenter;
        mostVisibleSentenceIndex = index;
      }
    });

    if (mostVisibleSentenceIndex !== -1 && mostVisibleSentenceIndex !== currentSentenceIndex) {
      sentences[currentSentenceIndex]?.classList.remove('active');
      currentSentenceIndex = mostVisibleSentenceIndex;
      sentences[currentSentenceIndex].classList.add('active');
    }
  });
}

// Banner Toggle on Scroll
const banner = document.querySelector('.case-page-header--banner');
const content = document.querySelector('.case-page-content');
const logotype = document.querySelector('.case-page-header--logotype');

function handleScroll() {
  const logotypeHeight = logotype.offsetHeight; // Get the dynamic height of the logotype
  banner.classList.toggle('show', window.pageYOffset > logotypeHeight);
  content.classList.toggle('show', window.pageYOffset > logotypeHeight);
}

// Recalculate logotype height on window resize
function handleResize() {
  handleScroll(); // Call handleScroll to adjust the toggle behavior
}

window.addEventListener('scroll', handleScroll);
window.addEventListener('resize', handleResize);

// Initial check on load
handleScroll();

// Initialize all functions after DOM has fully loaded
document.addEventListener("DOMContentLoaded", () => {
  // Initialize word switcher
  setTimeout(cycleWords, 2000);

  // Initialize lock words on scroll
  document.querySelectorAll('.highlight-section').forEach(initHighlightForLockScrollSection);

  // Initialize update figures
  setInterval(updateFigureNumbers, 10000);
  updateFigureNumbers();

  // Initialize scroll handling for the banner
  window.addEventListener('scroll', handleScroll);

  // Re-evaluate lock words on scroll on window resize
  window.addEventListener("resize", () => {
    document.querySelectorAll('.highlight-section').forEach(lockScrollSection => {
      window.dispatchEvent(new Event('scroll'));
    });
  });
});

document.addEventListener("DOMContentLoaded", function() {
    const playButtons = document.querySelectorAll('.video-play');

    playButtons.forEach(button => {
        button.addEventListener('click', function() {
            console.log('Dataset:', this.dataset); // Debug: Log dataset
            const vimeoId = this.dataset.vimeoId;

            if (!vimeoId) {
                console.error('Vimeo ID is null or undefined.', this);
                return; // Exit if no ID found
            }

            const figure = this.closest('.case-media-large');
            const iframeHtml = `<iframe src="https://player.vimeo.com/video/${vimeoId}?autoplay=1&loop=1&muted=0" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style="width: 100%; height: 100%; position: absolute; top: 0; left: 0;"></iframe>`;

            // Replace figure's innerHTML with iframe
            figure.innerHTML = iframeHtml;

            // Adjustments for video container
            figure.style.position = 'relative';
            figure.style.paddingTop = '56.25%'; // Maintain a 16:9 aspect ratio
        });
    });
});
